"use client";
import { component } from "@gnist/component-utils";
import { columnRecipe } from "./styles.css.js";
const Column = component("Column", columnRecipe, "div");
export {
  Column
};
